import { Box, CircularProgress } from "@mui/material";
import React from "react";

interface Props {

}

const LoadingSpinner : React.FC<Props> = () => {
    return <Box sx={{margin: '0 auto'}}><CircularProgress /></Box>
}

export default LoadingSpinner;